import {
  useCompositeGroup
} from "../__chunks/6FAQA4RZ.js";
import "../__chunks/2NIRKFVH.js";
import "../__chunks/F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/select/select-group.ts
var useSelectGroup = createHook((props) => {
  props = useCompositeGroup(props);
  return props;
});
var SelectGroup = createComponent((props) => {
  const htmlProps = useSelectGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  SelectGroup.displayName = "SelectGroup";
}
export {
  SelectGroup,
  useSelectGroup
};
